<template>
    <div class="loading" :class="active">
        <div class="loading-container">
            <div class="loading--spinner">&nbsp;</div>
            <div class="loading--message">Cargando, por favor espere...</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
    computed: {
        ...mapGetters("AppStore", ["_loading"]),
        active() {
            return this._loading ? "fadeIn" : "fadeOut"
        }
    },

}
</script>
<style scoped>
.loading {
    --zi: 100;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--zi);
    width: 100%;
    height: 100%;
    border: none;
    background-color: #00000098;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    z-index: calc(var(--zi) + 1);
}

.loading--spinner {
    width: 40px;
    height: 40px;
    border: 2px solid transparent;
    border-left-color: #fff;
    border-radius: 50%;
    animation: spin 1s ease infinite;
}

.loading--message {
    color: #fff;
}

.fadeIn {
    animation: fade-in .2s;
    animation-fill-mode: forwards;
}

.fadeOut {
    animation: fade-out .2s;
    animation-fill-mode: forwards;
}
</style>